<template>
    <div>
        <z-title title="提成设置" ref="title"></z-title>
        <el-card ref="search">
            <div class="flex-n fac fjb">
                <el-input
                        size="medium"
                        class="ele-input"
                        placeholder="输入提成名称"
                        maxlength="20"
                        clearable
                        title="输入要搜索的提成名称"
                        prefix-icon="el-icon-search"
                        v-model="commissionTitle">
                </el-input>
                <div class="flex-n fac">
                    <el-button type="primary" class="ele-btn2" @click="searchList">查询</el-button>
                    <el-button type="primary" class="ele-btn2" @click="addCommission">新增</el-button>

                </div>
            </div>
        </el-card>
        <el-card class="mt-10">
            <!--列表-->
            <el-table
                      :data="tableData"
                      v-loading="loading"
                      :height="height+'px'"
                      highlight-current-row
                      element-loading-text="列表刷新中"
                      header-cell-class-name="headerrow"
                      cell-class-name="cellclass"
                      style="width: 100%">
                <el-table-column
                        fixed="left"
                        prop="commissionTitle"
                        label="提成名称"
                        align="center"
                        width="240">
                </el-table-column>
                <el-table-column
                        prop="orderCategory"
                        label="所属订单"
                        align="center"
                        width="140">
                    <template slot-scope="scope">
                        {{scope.row.orderCategory=='0'?'普通(预定)订单':'婚庆订单'}}
                    </template>
                </el-table-column>
                <el-table-column
                        prop="commissionName"
                        label="规则名称"
                        align="center"
                        width="160">
                </el-table-column>
                <el-table-column
                        prop="commissionValueType"
                        label="规则"
                        align="center">
                    <template slot-scope="scope">
                        {{scope.row.commissionValue}}
                        {{scope.row.commissionValueType=='1'?'元':''}}
                        {{scope.row.commissionValueType=='2'?'%':''}}
                    </template>
                </el-table-column>
                <el-table-column
                        label="操  作"
                        fixed="right"
                        width="120"
                        align="center"
                >
                    <template slot-scope="scope">
                        <div style="margin: 5px 0">
                            <el-button type="primary" class="ele-btn-small mr-10" @click="editCommission(scope.row.id)">编辑</el-button>

                            <el-popconfirm
                                    title="确定删除提成规则吗？"
                                    @confirm="delCommission(scope.row.id)"
                            >
                                <el-button  slot="reference" type="primary" class="ele-btn-small">删除</el-button>
                            </el-popconfirm>

                        </div>
                    </template>
                </el-table-column>
            </el-table>
            <!--分页-->
            <pagination :current-page="currentPage" :page-size="pageSize" :total="total"   @sizeChange="handleSizeChange"
                        @currentChange="handleCurrentChange"></pagination>
        </el-card>
        <edit-commission  :visible.sync="visible" :id="id" :type="type" @refresh="searchList"></edit-commission>
    </div>
</template>

<script>
    import ZTitle from "../../components/ZTitle";
    import Pagination from "../../components/pagination/pagination";
    import EditCommission from "./sub/EditCommission";

    export default {
        components: {
            EditCommission,
            Pagination,
            ZTitle},
        name: "commission",
        data(){
            return{
                loading: false,
                currentPage: 1,
                pageSize: 20,
                total: 0,
                height: 250,
                tableData: [],
                id: '',

                type:0,
                visible:false,

                commissionTitle:'',
                orderCategory:'',
            }
        },
        mounted() {
            setTimeout(()=>{
                this.height=document.body.offsetHeight -this.$refs.title.$el.offsetHeight-this.$refs.search.$el.offsetHeight - 180;
                console.log(this.height)
            },0)
            this.loading = true;
            this.getDataList();
        },
        methods:{
            searchList() {
                this.currentPage = 1;
                this.loading = true;
                this.getDataList();
            },
            getDataList(){
                this.$axios.post('/orderCommissionConfig/commissionList',{
                    "storeId": this.$root.getStorage('storeId'),
                    "commissionTitle":this.commissionTitle,
                    "orderCategory": this.orderCategory,
                    "currentPage":this.currentPage,
                    "pageSize":this.pageSize,
                }).then(res=>{
                    this.tableData=res.data.list;
                    this.total=res.data.total;
                     this.loading=false;
                }).catch(err=>{
                    this.$message.error(err.msg);
                })
            },
            delCommission(id){
                this.$axios.get('/orderCommissionConfig/commissionDelete/'+id).then(res=>{
                    this.$message.success('删除提成设置成功');
                    this.getDataList();
                }).catch(err=>{
                    this.$message.error(err.msg);
                })
            },
            addCommission(){
                this.type=0;
                this.visible=true;
            },
            editCommission(id){
                this.id=id;
                this.visible=true;
                this.type=1;
            },
            handleSizeChange(val) {
                this.pageSize = val;
                this.loading = true;
                this.getDataList();
                console.log(`每页 ${val} 条`);
            },
            handleCurrentChange(val) {
                this.currentPage = val;
                this.loading = true;
                this.getDataList();
                console.log(`当前页: ${val}`);
            }
        }
    }
</script>

<style scoped>

</style>